(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/lb-nav-menu/assets/javascripts/lb-nav-menu.js') >= 0) return;  svs.modules.push('/components/casino-react/lb-nav-menu/assets/javascripts/lb-nav-menu.js');
"use strict";


const _svs$ui$ReactItemsMen = svs.ui.ReactItemsMenu,
  ItemsMenu = _svs$ui$ReactItemsMen.ItemsMenu,
  LinkItem = _svs$ui$ReactItemsMen.LinkItem,
  ItemsMenuIcon = _svs$ui$ReactItemsMen.ItemsMenuIcon;
const Icon = svs.ui.ReactIcon;
const baseUrl = svs.core.data.baseUrl;
const casinoHome = svs.core.urlMapping.get('casinoHome');
const navigationStripe = svs.casino_react.shared.data.navigationStripe;
const LbNavMenu = () => {
  const activeRoutes = svs.lb_casino_search.data.renderModel.activeRoutes;
  return React.createElement("div", {
    className: "lb-casino-main-navigation"
  }, React.createElement(ItemsMenu, {
    branding: "casino2",
    centered: true,
    hiddenScrollbar: true
  }, activeRoutes.map(route => React.createElement(LinkItem, {
    className: "lb-casino-main-navigation__icon-item".concat(casinoHome + route.path === baseUrl ? '--selected' : ''),
    Component: "a",
    href: casinoHome + route.path,
    key: route.label,
    label: route.label,
    selected: casinoHome + route.path === baseUrl
  }, Boolean(route.icon) && React.createElement(ItemsMenuIcon, {
    color: "casino",
    icon: route.icon,
    position: "top",
    size: "200"
  })))), navigationStripe && React.createElement("div", {
    className: "lb-casino-main-navigation__stripe"
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: navigationStripe.icon,
    size: "50"
  }), React.createElement("span", {
    className: "lb-casino-main-navigation__stripe-content"
  }, navigationStripe.message)));
};
setGlobal('svs.components.casino_react.lbNavMenu', LbNavMenu);

 })(window);